// Função utilitária para formar URLs completas de imagens

// Para uploads, construir URL base do backend
const getBackendBaseUrl = () => {
  const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';
  // Se termina com /api, remove. Senão, usa como está
  return apiUrl.endsWith('/api') ? apiUrl.slice(0, -4) : apiUrl;
};

const BACKEND_BASE_URL = getBackendBaseUrl();

export const getImageUrl = (imageUrl?: string | null): string => {
  console.log('🔍 getImageUrl chamada com:', imageUrl);
  console.log('🔍 BACKEND_BASE_URL:', BACKEND_BASE_URL);
  console.log('🔍 Tipo do imageUrl:', typeof imageUrl);
  
  if (!imageUrl) {
    console.log('🔍 imageUrl vazio, usando padrão');
    return '/images/default-campaign.jpg'; // Usar imagem padrão local
  }

  // Se já é uma URL completa, retorna como está
  if (imageUrl.startsWith('http')) {
    console.log('🔍 URL completa detectada:', imageUrl);
    return imageUrl;
  }

  // Se começa com /uploads/, construir URL completa para o backend
  if (imageUrl.startsWith('/uploads/')) {
    const backendUrl = `${BACKEND_BASE_URL}${imageUrl}`;
    console.log('🔍 URL de upload detectada!');
    console.log('🔍 ImageUrl original:', imageUrl);
    console.log('🔍 BACKEND_BASE_URL:', BACKEND_BASE_URL);
    console.log('🔍 URL final construída:', backendUrl);
    
    // Adicionar timestamp para evitar cache em desenvolvimento
    const finalUrl = `${backendUrl}?t=${Date.now()}`;
    console.log('🔍 URL com timestamp anti-cache:', finalUrl);
    return finalUrl;
  }

  // Se começa com /, mas não é /uploads/, tentar como caminho local primeiro
  if (imageUrl.startsWith('/')) {
    console.log('🔍 Caminho absoluto detectado, tentando local:', imageUrl);
    return imageUrl;
  }

  // Se não começa com /, assumir que está na pasta uploads do backend
  const finalUrl = `${BACKEND_BASE_URL}/uploads/${imageUrl}`;
  console.log('🔍 Caminho relativo, construindo URL do backend:', finalUrl);
  return finalUrl;
};

export const isValidImageUrl = (url?: string | null): boolean => {
  if (!url) return false;
  
  const validExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.webp'];
  const lowerUrl = url.toLowerCase();
  
  return validExtensions.some(ext => lowerUrl.includes(ext));
}; 